const { REACT_APP_SENTRY_URL, REACT_APP_ENV } = process.env;
export const initSentry = () => {
    // Sentry.init({
    //   dsn: REACT_APP_SENTRY_URL,
    //   enabled: REACT_APP_ENV === "production",
    //   release: REACT_APP_RELEASE,
    // });
};
